// Land on a 1° grid from Natural Earth (world-atlas land-50m), 84°N downwards and
// without Antarctica. Each row is run lengths of alternating water and land cells from 180°W.
export const LAND = {
  step: 1,
  top: 84,
  rows: [
    "360",
    "103,3,1,1,1,3,22,14,1,6,205",
    "91,3,1,22,4,5,1,2,1,4,1,15,1,4,2,2,1,1,199",
    "85,3,5,1,1,18,2,42,1,8,68,2,1,2,1,1,3,1,28,4,83",
    "80,1,2,10,1,3,1,11,6,45,1,2,33,1,2,8,23,1,8,1,31,2,2,4,81",
    "75,2,1,1,7,7,3,6,1,1,7,49,32,9,75,4,1,3,76",
    "65,1,2,2,9,2,2,2,10,9,4,50,36,4,3,2,76,1,80",
    "60,4,20,1,6,10,8,53,33,2,50,1,33,6,73",
    "57,3,3,5,2,2,1,1,2,6,6,2,30,40,80,6,27,4,1,15,25,2,1,1,38",
    "68,5,10,3,2,12,22,36,78,4,27,26,25,5,4,4,29",
    "56,7,18,1,3,4,35,34,77,3,29,22,31,1,39",
    "55,7,1,3,6,3,2,1,2,2,2,4,3,3,1,4,1,4,20,33,76,3,18,1,6,39,3,6,51",
    "54,6,1,11,1,2,5,3,7,14,1,1,19,1,1,30,75,3,14,4,3,1,1,3,1,47,11,6,1,3,30",
    "0,1,22,1,38,14,8,3,4,1,2,15,19,26,2,2,13,1,35,1,26,3,10,6,1,4,1,3,1,47,2,20,3,3,21,1",
    "17,20,12,1,2,1,2,1,7,16,5,4,8,3,1,1,1,11,12,2,1,1,1,28,41,1,2,7,30,1,7,6,1,86,11,1,8",
    "16,27,1,18,4,7,2,3,1,5,2,3,1,2,3,3,5,9,17,25,41,1,2,19,11,2,11,5,2,5,4,92,2,9",
    "0,4,11,50,7,5,4,3,1,7,1,5,5,11,13,21,47,25,4,3,3,23,2,2,1,102",
    "0,5,1,2,10,54,1,25,9,10,9,20,48,18,1,8,3,2,2,24,2,106",
    "1,9,3,81,12,7,1,3,10,14,1,2,12,1,1,1,4,2,28,22,6,139",
    "4,4,5,80,1,3,5,2,1,8,15,11,18,9,26,9,4,10,2,1,2,140",
    "19,67,1,3,3,3,1,2,8,8,13,11,19,6,26,11,2,13,2,140,2",
    "15,74,20,3,2,1,14,9,49,11,3,158,1",
    "14,73,13,1,1,5,6,1,17,7,47,12,4,142,1,11,5",
    "15,13,1,57,16,9,21,5,48,12,4,135,4,1,3,8,8",
    "13,1,2,1,1,9,1,5,6,1,1,44,18,6,6,1,20,1,48,14,4,1,6,125,6,3,2,1,13",
    "18,1,1,1,1,4,16,43,17,9,3,3,69,4,1,7,4,1,1,118,9,2,7,3,1,1,15",
    "22,3,18,44,16,15,55,1,1,1,16,5,7,117,17,4,18",
    "21,2,23,44,13,16,53,1,1,4,10,2,2,4,5,118,17,7,17",
    "19,2,27,45,7,1,2,16,55,3,11,2,2,2,7,116,19,6,18",
    "16,1,30,1,1,49,3,20,51,2,1,4,10,1,2,1,8,114,2,1,18,6,18",
    "47,1,1,49,3,22,47,4,3,3,9,2,1,2,1,123,1,1,16,4,20",
    "52,47,2,23,47,3,2,4,5,136,1,1,13,2,22",
    "52,47,1,24,46,2,3,6,3,137,1,1,13,2,19,1,2",
    "54,67,2,1,52,5,1,139,1,2,36",
    "53,60,9,1,58,140,1,2,36",
    "54,2,1,54,2,3,6,4,52,142,2,1,1,1,35",
    "55,55,1,3,1,1,5,5,49,145,2,1,37",
    "56,59,4,1,4,1,1,1,51,39,2,12,1,87,3,1,37",
    "56,60,1,1,1,1,59,31,4,1,3,11,4,85,42",
    "56,57,2,3,61,13,3,15,4,1,2,10,4,86,5,1,4,1,32",
    "56,55,3,1,64,9,2,3,2,14,10,8,4,85,6,2,36",
    "56,53,62,12,8,3,3,11,13,6,5,82,6,5,35",
    "56,53,62,12,9,3,4,9,5,1,8,6,4,1,1,76,10,1,39",
    "56,50,1,1,63,10,8,1,4,3,2,9,1,9,1,10,6,75,10,1,39",
    "56,50,65,9,8,2,6,1,3,4,2,23,4,67,2,6,12,2,38",
    "56,47,1,1,66,9,1,1,14,1,4,2,3,23,5,64,3,1,3,3,12,2,38",
    "57,48,66,8,14,2,6,2,1,1,2,22,5,65,6,4,9,3,39",
    "58,45,70,5,8,2,1,1,4,1,7,1,2,1,2,23,3,69,3,3,9,3,39",
    "58,45,77,11,25,84,7,3,6,5,39",
    "59,44,71,17,14,1,6,2,2,83,7,2,4,7,41",
    "62,40,71,17,26,84,14,2,44",
    "63,37,71,21,23,86,9,3,47",
    "63,36,72,24,5,4,11,87,8,2,48",
    "64,1,2,32,71,28,2,9,1,92,58",
    "64,1,2,24,3,5,71,59,1,72,58",
    "65,1,1,18,12,2,67,1,2,59,3,71,58",
    "66,1,2,14,14,2,65,1,2,46,2,14,2,70,59",
    "66,2,2,12,16,2,67,47,2,14,3,3,1,63,60",
    "68,1,2,12,15,2,65,49,3,14,6,63,60",
    "68,1,3,10,83,50,2,15,3,1,11,52,2,1,58",
    "69,1,3,9,23,1,58,52,2,19,10,51,2,2,58",
    "74,8,15,2,65,52,3,20,10,1,1,19,1,22,1,3,3,1,59",
    "20,1,53,8,13,1,4,2,61,54,2,21,9,3,1,17,2,21,67",
    "75,8,7,3,9,2,2,1,56,54,2,20,11,2,1,14,5,15,3,1,69",
    "24,1,50,8,7,3,9,3,59,53,3,18,15,13,7,13,4,1,69",
    "76,8,5,3,15,4,53,53,4,17,15,12,9,12,3,2,69",
    "78,14,10,2,4,1,4,1,50,55,3,14,17,11,10,12,14,2,58",
    "80,12,72,55,4,11,19,9,12,13,13,2,58",
    "82,3,1,5,72,56,4,9,22,7,13,2,2,10,12,2,58",
    "87,10,59,1,6,57,3,7,24,6,18,11,11,2,58",
    "89,8,66,59,1,5,27,5,18,11,12,2,57",
    "93,3,67,62,30,5,19,1,1,8,14,1,56",
    "93,3,12,1,55,59,32,5,18,2,3,6,71",
    "94,2,9,3,1,3,53,59,3,4,25,4,18,2,4,4,11,1,2,1,1,1,55",
    "94,3,7,4,1,9,48,65,25,3,26,2,16,2,55",
    "96,2,1,3,2,15,48,64,26,1,2,1,17,2,25,1,54",
    "98,2,2,19,46,63,30,2,17,1,22,4,54",
    "102,19,47,61,31,2,18,1,23,2,54",
    "103,20,47,11,4,44,31,1,19,2,14,2,7,1,54",
    "103,25,43,3,3,1,7,43,47,3,2,3,12,4,61",
    "103,26,60,39,48,3,2,2,11,4,62",
    "102,27,61,37,50,3,1,2,9,6,62",
    "101,28,61,35,53,4,1,1,7,7,62",
    "100,30,60,34,53,1,1,4,1,1,4,10,2,1,2,1,2,2,51",
    "88,1,11,29,1,1,58,34,57,4,5,8,63",
    "99,32,1,1,56,33,58,4,5,8,2,1,1,2,8,3,46",
    "99,36,54,32,60,5,4,6,3,2,3,1,7,2,3,2,41",
    "100,35,1,4,50,30,61,6,5,4,3,1,1,1,6,2,2,3,1,6,9,1,28",
    "99,43,49,29,62,4,15,2,12,10,35",
    "99,44,49,27,65,2,13,1,2,1,14,9,5,1,28",
    "99,46,47,27,81,1,13,1,3,9,2,2,29",
    "100,45,48,27,66,8,25,8,33",
    "101,44,48,26,71,4,24,6,2,2,9,1,22",
    "101,44,48,26,78,1,7,1,15,2,4,2,31",
    "102,42,49,27,80,1,3,1,23,2,30",
    "102,41,51,27,101,1,37",
    "103,39,52,27,92,1,2,1,5,1,37",
    "104,37,52,28,8,1,80,7,5,1,37",
    "8,1,95,37,51,29,7,2,80,7,5,2,36",
    "105,36,51,29,7,2,75,11,6,3,35",
    "106,35,51,28,5,5,75,12,4,4,35",
    "108,33,51,27,5,6,72,1,1,16,1,5,34",
    "109,32,51,25,7,5,73,24,31,2,1",
    "110,30,52,24,8,5,73,24,34",
    "110,30,53,22,9,5,71,28,32",
    "110,29,55,21,9,4,7,1,60,33,31",
    "110,29,55,21,8,5,67,35,16,1,13",
    "110,27,57,22,7,5,66,37,29",
    "109,25,60,22,8,3,66,38,29",
    "110,22,63,19,10,3,67,39,27",
    "109,22,64,18,81,39,27",
    "109,22,64,18,81,39,27",
    "109,22,65,17,81,39,27",
    "108,23,66,15,83,38,27",
    "109,21,67,14,84,38,27",
    "108,21,69,12,85,38,27",
    "108,20,70,11,87,12,5,20,27",
    "108,19,71,10,88,8,10,18,28",
    "108,18,72,8,89,5,15,1,2,13,29",
    "108,14,175,1,19,1,1,12,22,1,6",
    "107,16,194,1,1,11,24,1,5",
    "107,16,197,10,30",
    "107,15,199,7,27,3,2",
    "107,11,236,4,2",
    "106,12,237,2,3",
    "106,9,1,1,208,1,1,1,24,1,2,1,4",
    "108,7,210,3,23,3,6",
    "106,10,210,2,23,2,7",
    "3,1,103,8,234,3,8",
    "107,7,233,4,9",
    "105,7,235,3,10",
    "106,7,247",
    "106,8,246",
    "104,8,137,1,110",
    "106,5,249",
    "105,6,249",
    "106,5,8,2,239",
    "107,1,2,2,248",
    "107,6,29,1,217",
    "109,5,246",
    "360",
    "360"
  ]
}

// Centres of the land cells as [lng, lat].
export function landPoints() {
  const points = []
  LAND.rows.forEach((row, r) => {
    const lat = LAND.top - r * LAND.step
    let column = 0
    row.split(",").forEach((run, i) => {
      const length = Number(run)
      if (i % 2 === 1) {
        for (let c = column; c < column + length; c++) points.push([ -180 + LAND.step / 2 + c * LAND.step, lat ])
      }
      column += length
    })
  })
  return points
}
